<template>
    <g>
      <g transform="scale(0.7)">
        <text transform="matrix(1 0 0 1 90 40)" class="name"
            >LED{{ number }}</text>
        <rect x="81.66" y="88.54" class="st0" width="53.92" height="8.22"/>
        <g transform="translate(-4,0)">
            <g class="pin">
                <rect
                    x="98.62"
                    y="95.76"
                    class="st1"
                    width="5.59"
                    height="43.56"
                />
                <rect
                    :id="pincode + 'MS'"
                    @click="onClick(`${pincode}MS`)"
                    class="pin-cover terminal snap"
                    x="91.62"
                    y="135.76"
                    width="15"
                    height="15"
                />
            </g>
            <linearGradient
                id="SVGID_2_Led"
                gradientUnits="userSpaceOnUse"
                x1="110.4247"
                y1="128.8151"
                x2="116.0137"
                y2="128.8151"
            >
                <stop offset="0" style="stop-color:#FFFFFF" />
                <stop offset="1.868180e-08" style="stop-color:#EDEDED" />
                <stop offset="5.778535e-08" style="stop-color:#CECECE" />
                <stop offset="1.020835e-07" style="stop-color:#B2B2B2" />
                <stop offset="1.521744e-07" style="stop-color:#9C9C9C" />
                <stop offset="2.106337e-07" style="stop-color:#8B8B8B" />
                <stop offset="2.829547e-07" style="stop-color:#808080" />
                <stop offset="3.843944e-07" style="stop-color:#797979" />
                <stop offset="6.659737e-07" style="stop-color:#777777" />
                <stop offset="0.1529" style="stop-color:#979392" />
                <stop offset="0.332" style="stop-color:#A3A2A2" />
                <stop offset="0.4162" style="stop-color:#A0A0A1" />
                <stop offset="0.571" style="stop-color:#9D9D9E" />
                <stop offset="0.6867" style="stop-color:#949494" />
                <stop offset="0.7898" style="stop-color:#848484" />
                <stop offset="0.8854" style="stop-color:#6D6D6E" />
                <stop offset="0.9751" style="stop-color:#505051" />
                <stop offset="1" style="stop-color:#474747" />
            </linearGradient>
        </g>
            <linearGradient id="SVGID_1_Led" gradientUnits="userSpaceOnUse" x1="96.6164" y1="118.5412" x2="102.2055" y2="118.5412">
                <stop  offset="0" style="stop-color:#FFFFFF"/>
                <stop  offset="1.868180e-08" style="stop-color:#EDEDED"/>
                <stop  offset="5.778535e-08" style="stop-color:#CECECE"/>
                <stop  offset="1.020835e-07" style="stop-color:#B2B2B2"/>
                <stop  offset="1.521744e-07" style="stop-color:#9C9C9C"/>
                <stop  offset="2.106337e-07" style="stop-color:#8B8B8B"/>
                <stop  offset="2.829547e-07" style="stop-color:#808080"/>
                <stop  offset="3.843944e-07" style="stop-color:#797979"/>
                <stop  offset="6.659737e-07" style="stop-color:#777777"/>
                <stop  offset="0.1529" style="stop-color:#979392"/>
                <stop  offset="0.332" style="stop-color:#A3A2A2"/>
                <stop  offset="0.4162" style="stop-color:#A0A0A1"/>
                <stop  offset="0.571" style="stop-color:#9D9D9E"/>
                <stop  offset="0.6867" style="stop-color:#949494"/>
                <stop  offset="0.7898" style="stop-color:#848484"/>
                <stop  offset="0.8854" style="stop-color:#6D6D6E"/>
                <stop  offset="0.9751" style="stop-color:#505051"/>
                <stop  offset="1" style="stop-color:#474747"/>
            </linearGradient>
        <g transform="translate(8,0)">
            <g class="pin">
                <rect
                    x="110.42"
                    y="96.76"
                    class="st2"
                    width="5.59"
                    height="64.11"
                />
                <rect
                    :id="pincode+ 'PS'"
                    @click="onClick(`${pincode}PS`)"
                    class="pin-cover terminal snap"
                    x="105.42"
                    y="150.76"
                    width="15"
                    height="15"
                ></rect>
            </g>
            <linearGradient
                id="SVGID_3_Led"
                gradientUnits="userSpaceOnUse"
                x1="88.9037"
                y1="66.8493"
                x2="128.3759"
                y2="66.8493"
            >
                <stop offset="0" style="stop-color:#E60012" />
                <stop offset="0.0834" style="stop-color:#E84024" />
                <stop offset="0.2096" style="stop-color:#EB6A42" />
                <stop offset="0.3243" style="stop-color:#EE855C" />
                <stop offset="0.4223" style="stop-color:#F0946D" />
                <stop offset="0.4922" style="stop-color:#F09A74" />
                <stop offset="0.5632" style="stop-color:#EF946C" />
                <stop offset="0.671" style="stop-color:#EE8158" />
                <stop offset="0.802" style="stop-color:#EB623B" />
                <stop offset="0.9501" style="stop-color:#E72D1B" />
                <stop offset="1" style="stop-color:#E60012" />
            </linearGradient>
        </g>
        <g id="led-header">
            <path
                class="st3"
                d="M88.9,88.54h39.47V59.18c0,0,0.78-13.84-19.73-13.98c0,0-18.47-1.46-19.68,13.61L88.9,88.54z"
            />
        </g>
        <radialGradient
            id="SVGID_4_Led"
            cx="127.0315"
            cy="71.8729"
            r="11.2567"
            gradientTransform="matrix(1.1338 0 0 1.0297 -35.6083 2.2098)"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset="0" style="stop-color:#FFFFFF" />
            <stop offset="0.0859" style="stop-color:#FEF7F8" />
            <stop offset="0.218" style="stop-color:#FCE2E4" />
            <stop offset="0.3799" style="stop-color:#F9BFC3" />
            <stop offset="0.5652" style="stop-color:#F48E96" />
            <stop offset="0.7703" style="stop-color:#EE4F5B" />
            <stop offset="0.9891" style="stop-color:#E60416" />
            <stop offset="1" style="stop-color:#E60012" />
        </radialGradient>
        <g v-if="on && isOvercurrent">
          <path transform="scale(0.1) translate(860, -250)" class="st5" d="M254,64.6l-1.7,1.8L32.8,439.7l-0.1,5.9l1.7,1.9l2.1,0.6h438.7l2.1-0.6l1.8-1.9l-0.1-5.9L259.8,66.4l-1.7-1.8
          l-2-0.5L254,64.6z M287.4,50.2c-9.9-17.3-32-23.3-49.3-13.4c-5.6,3.2-10.2,7.8-13.4,13.4L5.3,423.4C-9.4,448.3,8.2,480,36.6,480
          h438.7c28.4,0,46-31.7,31.3-56.6L287.4,50.2z"/>
          <polygon transform="scale(0.1) translate(950, -130)" points="252.086,178.355 171.154,144.27 231.9,0 74.301,148.018 155.236,182.104 94.487,326.387 "/>
        </g>
        <!-- <path class="st4" d="M96.62,88.62h23.61V71.83c0,0,0.47-7.91-11.8-7.99c0,0-11.04-0.83-11.77,7.78L96.62,88.62z"/> -->
    </g>
  </g>
</template>

<script>
import store from '../../../../store/index.js'
import { pins } from '../../../../mixins/pin-util.js'

export default {
  props: ['data'],
  mixins: [pins],
  name: 'Led',
  data () {
    return {
      timemax: null,
      on: false,
      isOvercurrent: false,
      selector: `#${this.data.id} #led-header .st3`
    }
  },
  mounted () {
    this.setPindata(this.data)
  },
  methods: {
    onClick (pin) {
      const name = this.data.id
      store.commit('wire/createLines', { name, pin })
      window.event.stopPropagation()
    },
    fadeInOut (value) {
      if (this.on) {
        // 과전류
        if (value >= 258) {
          this.isOvercurrent = true
          return
        }
        this.isOvercurrent = false
        value = value / 255 + 0.1
        this.timemax = new window.TimelineMax({ repeat: 0 })
        this.timemax.to(this.selector, { css: { fill: '#E60012', stroke: '#E60012', opacity: value } })
      }
    },
    lightingOut () {
      if (this.on) {
        this.timemax = new window.TimelineMax({ repeat: 0 })
        this.timemax.to(this.selector, { css: { fill: '#ef9a9a', stroke: '#ef9a9a', opacity: 0.7 } })
      }
    },
    lighting () {
      if (this.on) {
        this.timemax = new window.TimelineMax({ repeat: 0 })
        this.timemax.to(this.selector, { css: { fill: '#f93535', stroke: '#f93535', opacity: 1.0 } })
      }
    },
    blinking () {
      window.event.stopPropagation()
      if (this.on) {
        if (!this.timemax) {
          this.timemax = new window.TimelineMax({ repeat: -1 })
          this.timemax.to('#led-header', 0.7, { alpha: 0.3 })
            .to('#led-header', 0.7, { alpha: 1.5 })
        } else {
          this.timemax.kill()
          this.timemax = null
        }
      }
    },
    start (socket) {
      this.on = true
      socket.onmessage = ({ data }) => {
        data = JSON.parse(data)
        if (data.value === 1) {
          this.lighting()
        } else if (data.value === 0) {
          this.lightingOut()
        } else {
          this.fadeInOut(data.value)
        }
      }
    },
    startWithInterval (value) {
      this.on = true
      if (value === 1) {
        this.lighting()
      } else if (value === 0) {
        this.lightingOut()
      } else {
        this.fadeInOut(value)
      }
    },
    off () {
      this.on = false
      this.isOvercurrent = false
      this.timemax = new window.TimelineMax({ repeat: 0 })
      this.timemax.to(this.selector, { css: { fill: '#ef9a9a', stroke: '#ef9a9a', opacity: 0.7 } })
      this.timemax = null
    }
  }
}
</script>

<style lang="scss" scoped>
.pin-cover {
    display: block;
    stroke: none;
    fill: none;
}

.pin:hover {
    cursor: pointer;
    .pin-cover {
        stroke-width: 3px;
        stroke: black;
        fill: #ff6f61;
    }
}
.selected {
    & path.st3,
    & rect.st1,
    & rect.st2 {
        display: block;
        stroke-width: 4px;
        stroke: #ff6f61;
    }
}
.name {
    font-size: 18px;
}
.st0 {
    fill: #fc5c4d;
}
.st1 {
    fill: url(#SVGID_1_Led);
}
.st2 {
    fill: url(#SVGID_2_Led);
}
.st3 {
    fill: #ef9a9a;;
    stroke: #ef9a9a;;
    stroke-width: 4;
    stroke-miterlimit: 10;
}
.st4 {
    fill: url(#SVGID_4_Led);
}
.st5 {
  fill-rule:evenodd;
  clip-rule:evenodd;
}
</style>
